import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";
// core components

function NucleoIcons() {
  // Get today's date
  const history = useHistory();
  const today = new Date();
  // const isBeforeNovember =
  //   today.getFullYear() === new Date().getFullYear() && today.getMonth() < 11;
  const isBeforeNovember2025 =
    today.getFullYear() < 2025 ||
    (today.getFullYear() === 2025 && today.getMonth() < 10);
  // State for Modal visibility
  const [modalOpen, setModalOpen] = useState(false);

  // Show modal if early bird offer is active
  useEffect(() => {
    if (isBeforeNovember2025) {
      setModalOpen(true);
    }
  }, [isBeforeNovember2025]);

  const toggleModal = () => setModalOpen(!modalOpen);
  const handleImageClick = () => {
    // Navigate to the registration page
    history.push("/registration");
  };
  return (
    <>
      <div className="section section-nucleo-icons py-5 my-5">
        <Container>
          <Row>
            <Col lg="4" md="12" className="hidden-sm hidden-xs">
              <div className="custom-module">
                <div className="d-lg-block d-none text-center mt-3">
                  <img
                    src={require("assets/img/fredrik-new-2025.jpg")}
                    className="img-responsive mb-3"
                    alt="founder"
                  />
                  <strong>Fredrik Nyberg</strong>
                  <br />
                  Network Director
                </div>
                <div className="d-lg-none text-center">
                  {/* <img src="images/Directors.png" className="img-responsive mb-3"
                    style="border: 2px solid #f47920;" alt="founder" /> */}
                  {/* <img src={require("assets/img/Fredrik.png")} className="img-responsive" alt="founder" style={{ width: "200px" }} />
                  <strong>Fredrik Nyberg</strong><br />Network Director */}

                  <div className="col-md-4 hidden-sm hidden-xs m-auto">
                    <div className="custom-module">
                      <div className="text-center w-100">
                        <img
                          src={require("assets/img/fredrik-new-2025.jpg")}
                          alt="Fredrik"
                          className="d-block m-auto director-image pb-4"
                          style={{ width: "200px" }}
                        />
                        <br />
                        <strong>Fredrik Nyberg</strong>
                        <br />
                        Network Director
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="8" md="12">
              <div className="">
                {/* <h6 className="text-uppercase text-primary mb-3">Director's message</h6> */}
                <p className="font-weight-bold mt-3">
                  Dear Friends and Partners,{" "}
                </p>
                <p>
                  It brings me great joy to once again welcome our global
                  community — this time to the vibrant city of{" "}
                  <span className="font-weight-bold">Macau</span>, for the{" "}
                  <span className="font-weight-bold">
                    FIBS Global Conference 2026
                  </span>
                  , set to take place at the iconic{" "}
                  <span className="font-weight-bold">Studio City</span> from{" "}
                  <span className="font-weight-bold">March 3 to 6.</span>
                </p>
                <p>
                  Following our unforgettable gathering in Da Nang, I remain
                  deeply inspired by the strength, resilience, and diversity of
                  our network. The FIBS Global Conference continues to be more
                  than just an event — it is a celebration of global
                  collaboration, shared vision, and enduring partnerships.
                </p>

                <p>
                  Next year, we are especially excited to{" "}
                  <span className="font-weight-bold">
                    co-host the event with our friends from the TPF Network
                  </span>
                  , who will be holding their own Face-to-Face meetings
                  alongside the main program. This collaboration will foster new
                  synergies and broaden our reach, bringing together even more
                  participants from across the world — a true testament to the
                  power of collective connection.
                </p>
                <p>
                  As we look ahead to 2026, we invite you to prepare for four
                  days of meaningful dialogue, cross-border collaboration, and
                  opportunities to forge new paths forward — both professionally
                  and personally. It will be a time not only to reconnect, but
                  to reimagine what we can achieve together in a rapidly
                  changing logistics landscape.
                </p>
                <p>
                  Thank you for being part of this journey. We cannot wait to
                  welcome you to Macau — and to once again grow, learn, and lead
                  together.
                </p>
                <p className="font-weight-bold mb-0">See you in Studio City.</p>
                <em>
                  <p>Growing Together. Your Global Family.</p>
                </em>
              </div>
            </Col>
          </Row>
        </Container>

        <div>
          <Modal isOpen={modalOpen} toggle={toggleModal} size="lg" centered>
            <ModalBody className="p-0 position-relative">
              <img
                src={require("assets/img/early-bird-v2.png")}
                alt="Example Image"
                className="img-fluid" // This makes the image responsive
                onClick={handleImageClick}
                style={{ cursor: "pointer" }}
              />
              <button
                className="btn-close position-absolute top-0 end-0 m-2 transparent-close-btn"
                onClick={toggleModal}
                aria-label="Close"
              >
                X
              </button>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default NucleoIcons;
